import locale from 'date-fns/locale/zh-TW'

export default locale
